import script from "./SettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=4241a295&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4241a295"]])

export default __exports__